import { DepartureRow } from '@modules/departures/models/departureRow';
import { DepartureOrArrivalSorting } from '@shared/models/departureOrArrivalSorting';
import { ArrivalRow } from '@modules/arrivals/models/arrivalRow';
import { DeepReadonly } from 'ts-essentials';
import { compareLines } from './compareLines';
import compareStrings from './compareStrings';

export function compareRows(
  first: DeepReadonly<DepartureRow> | DeepReadonly<ArrivalRow>,
  second: DeepReadonly<DepartureRow> | DeepReadonly<ArrivalRow>,
  sorting: DepartureOrArrivalSorting,
): number {
  if (sorting === 'time' && first.next.time !== second.next.time) {
    return first.next.time - second.next.time;
  }

  const lineComparison = compareLines(
    first.line.shortName,
    second.line.shortName,
  );
  if (lineComparison !== 0) {
    return lineComparison;
  }

  if ('origin' in first && 'origin' in second) {
    return compareStrings(first.origin, second.origin);
  }

  if ('destination' in first && 'destination' in second) {
    const nameComparison = compareStrings(
      first.destination.name,
      second.destination.name,
    );
    if (nameComparison !== 0) {
      return nameComparison;
    }

    const firstVia = first.destination.via;
    const secondVia = second.destination.via;

    if (firstVia == null && secondVia != null) {
      return -1;
    }
    if (firstVia != null && secondVia == null) {
      return 1;
    }
    if (firstVia != null && secondVia != null) {
      return compareStrings(firstVia, secondVia);
    }

    return 0;
  }

  return -1;
}
